<template>
  <v-row>
    <!-- <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label"
        >Need Date*
        <tip-icon>
          Select the date of the volunteer opportunity. If this is a "Runs
          until" need. Select the final date of the need.
        </tip-icon>
      </label>
      <v-menu
        v-model="date_picker"
        :close-on-content-click="false"
        :return-value.sync="endDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="need.end_date"
            label="MM/DD/YYYY"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
          />
        </template>
        <v-date-picker v-model="endDate" no-title scrollable :min="new Date().toISOString().substr(0, 10)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveEndDate(endDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col> -->
    <v-col
      cols="12"
      class="flex-row d-flex"
      style="align-items: baseline"
      ref="hours"
    >
      <label class="title-label"
        >Hours*
        <tip-icon>
          Enter the number of hours the volunteer is expected to work.<br />
          This number is used by your volunteer check-in feature.
          <br />For multi-date needs, Enter the average number of hours expected
          each day.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours"
        label="Example: 4 or 3.5"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="hoursMessage"
        @input="onChange"
      />
    </v-col>
    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="hours_description"
    >
      <label class="title-label"
        >Hours Description*
        <tip-icon>
          Let the volunteer know when the need is scheduled to start and end.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.hours_description"
        label="Example: 9am - 5pm"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :error-messages="hoursDescriptionMessage"
      />
    </v-col>
    <v-col
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="capacity"
    >
      <label class="title-label"
        >Capacity*
        <tip-icon>
          Enter the number of volunteer spots available.
        </tip-icon>
      </label>
      <v-text-field
        v-model="need.capacity"
        label="Example: 30"
        :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
        solo
        flat
        outlined
        dense
        :min="1"
        type="number"
        :error-messages="capacityMessage"
        @input="onCapacityInput"
      />
    </v-col>
      <!--  <v-col
   cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="registration_closed_date"
    >
      <label class="title-label"
        >Registration Closed Date*
        <tip-icon>
          Registration will close at midnight on this date. Volunteers can
          register before this date, but not on it.
        </tip-icon>
      </label>
      <v-menu
        v-model="date_picker_closed_date"
        :close-on-content-click="false"
        :return-value.sync="closedDate"
        transition="scale-transition"
        offset-y
        min-width="auto"
        :top="$vuetify.breakpoint.xs"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="need.registration_closed_date"
            label="MM/DD/YYYY"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            autocomplete="off"
            :error-messages="registrationClosedDateMessage"
          />
        </template>
        <v-date-picker v-model="closedDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="date_picker_closed_date = false">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="onSaveClosedDate(closedDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </v-col> -->

    <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
      ref="start_date"
    >
      <label class="title-label"
        >Happens On Date*
        <tip-icon>
          Select the date when the need is scheduled to start.
        </tip-icon>
      </label>
  <v-menu
    v-model="startDateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="need.start_date ? formatDateForDisplay(need.start_date) : ''"
          label="Select Happens On Date" 
          readonly
          solo
          flat
          outlined
          dense
          v-bind="attrs"
          v-on="on"
          :error-messages="startDateErrorMessage"
          :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
          placeholder="MM/DD/YYYY"
        />
    </template>
    <v-date-picker
      v-model="selectedStartDate"
      :min="today"
      @input="onStartDateSelected"
      no-title
      scrollable
    ></v-date-picker>
  </v-menu>
    </v-col>

    <!-- <v-col
      cols="12"
      class="align-baseline d-flex"
      :class="$vuetify.breakpoint.xs ? 'flex-column' : 'flex-row'"
    >
      <label class="title-label"
        >End Date*
        <tip-icon>
          Select the date when the need is scheduled to end.
        </tip-icon>
      </label>
      <v-menu
        v-model="endDateMenu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            :value="formattedEndDate"
            label="Select End Date"
            readonly
            solo
            flat
            outlined
            dense
            v-bind="attrs"
            v-on="on"
            :class="$vuetify.breakpoint.xs ? 'w-100' : 'ml-5'"
          />
        </template>
        <v-date-picker
          v-model="need.end_date"
          :min="new Date().toISOString().substr(0, 10)"
          @input="endDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-col> -->
  </v-row>
</template>
<script>
import TipIcon from "@/components/common/TipIcon.vue";
export default {
  components: { TipIcon },
  props: {
    need: Object,
    hoursMessage: String,
    onChange: Function,
    capacityMessage: String,
    hoursDescriptionMessage: String,
    startDateErrorMessage: String,
    // registrationClosedDateMessage: String
  },
  data() {
    return {
    date_picker: false,
    endDate: null,
    date_picker_closed_date: false,
    closedDate: null,
    startDateMenu: false,
    endDateMenu: false,
    selectedStartDate: null
    };
  },
  computed: {
  today() {
    return new Date().toISOString().substr(0, 10);
  },
  displayStartDate() {
    if (!this.need.start_date) {
      return '';
    }
    // Convert YYYY-MM-DD to MM/DD/YYYY format
    const [year, month, day] = this.need.start_date.split('-');
    return `${month}/${day}/${year}`;
  },
  formattedStartDate() {
    if (!this.need.start_date) return "";
    const date = new Date(this.need.start_date);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  },
  
  formattedEndDate() {
    if (!this.need.end_date) return "";
    const date = new Date(this.need.end_date);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  },
  methods: {
  onCapacityInput(value) {
    const numericValue = value.replace(/[^0-9]/g, "");
    if (numericValue === "" || Number(numericValue) < 1) {
      this.need.capacity = 1;
    } else {
      this.need.capacity = Number(numericValue);
    }
  },

    formatDateForDisplay(dateString) {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  },
  onStartDateSelected(date) {
    console.log('Start date selected:', date);
    
    // Use Vue.set to ensure reactivity
    this.$set(this.need, 'start_date', date);
    this.$set(this.need, 'end_date', date);
    this.selectedStartDate = date;
    this.startDateMenu = false;
    
    // Force component to update
    this.$forceUpdate();
    
    // Trigger any parent change handlers
    if (this.onChange) {
      this.onChange();
    }
  },
  changeDateFormat(dateStr) {
    return `${dateStr.substring(5, 7)}/${dateStr.substring(
      8,
      10
    )}/${dateStr.substring(0, 4)}`;
  },
  onSaveEndDate(dateStr) {
    this.need.end_date = this.changeDateFormat(dateStr);
    this.date_picker = false;
  },
  onSaveClosedDate(dateStr) {
    this.need.registration_closed_date = this.changeDateFormat(dateStr);
    this.date_picker_closed_date = false;
  }
  },
watch: {
  "need.start_date": {
    handler(newValue) {
      if (newValue) {
        this.need.end_date = newValue;
        this.selectedStartDate = newValue;
        console.log("End date set to current date:", this.need.end_date);
      }
    },
    immediate: true
  },
  selectedStartDate: {
    handler(newValue) {
      if (newValue && newValue !== this.need.start_date) {
        this.$set(this.need, 'start_date', newValue);
      }
    },
    immediate: true
  }
},
mounted() {
  // Initialize start date if not already set
  if (!this.need.start_date) {
    const today = new Date().toISOString().substr(0, 10);
    this.need.start_date = today;
    this.need.end_date = today;
    this.selectedStartDate = today;
    console.log("Start date initialized to current date:", this.need.start_date);
  } else {
    this.selectedStartDate = this.need.start_date;
    console.log("Existing start date:", this.need.start_date);
  }
}
};
</script>
<style scoped>
.title-label {
  width: 200px;
}
</style>
